import Hero from '../components/guest/sections/Hero';
import Services from '../components/guest/sections/Services';
import About from '../components/guest/sections/About';
import Contact from '../components/guest/sections/Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <About />
      <Contact />
    </>
  );
};

export default Home;